/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tables_Custom_Properties_Min_WidthInputs */

const en_tables_custom_properties_min_width = /** @type {(inputs: Tables_Custom_Properties_Min_WidthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Properties Min Width`)
};

const de_tables_custom_properties_min_width = /** @type {(inputs: Tables_Custom_Properties_Min_WidthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Min Breite`)
};

/**
* | output |
* | --- |
* | "Properties Min Width" |
*
* @param {Tables_Custom_Properties_Min_WidthInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const tables_custom_properties_min_width = /** @type {((inputs?: Tables_Custom_Properties_Min_WidthInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tables_Custom_Properties_Min_WidthInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_tables_custom_properties_min_width(inputs)
	return de_tables_custom_properties_min_width(inputs)
});